export default __webpack_public_path__ + "static/media/MACD.b25abc04.md";